// extracted by css-extract-rspack-plugin
var _1 = "YkQy5GcKdKkq5OLJ";
var _2 = "YkQy5GcKdKkq5OLJ";
var _3 = "dS0GBjmfn84HUTLh";
var _4 = "DIpzlTJm9gtVy13e";
var _5 = "rnmJGzJR0igvwL0w";
var _6 = "gQFSYhBN5YQP5d1k";
var _7 = "wJuLWkP_6R40boXG";
var _8 = "lcX47KTytC4PoU3y";
var _9 = "ghWBHwXXZLE5a0E1";
var _a = "Zt6zFiai_uU8Lzo0";
var _b = "JjwX1jmIjQ5Aj8z7";
var _c = "U8myoL9cSpUgZTJX";
var _d = "R9a2mcCpdsdq0mYm";
var _e = "BeA8ZVeuc0Yj00_T";
var _f = "Ldy5BtenA04wRD7b";
var _10 = "hhdv2VdZH146tQ8o";
var _11 = "xl3nLrTiHwTrWUih";
var _12 = "Tx2cneMtRsQsltP7";
var _13 = "LPdwjk3Fh4O6U_PM";
var _14 = "OW1BaPgxscYBBnny";
var _15 = "dS0GBjmfn84HUTLh";
var _16 = "DIpzlTJm9gtVy13e";
var _17 = "rnmJGzJR0igvwL0w";
var _18 = "gQFSYhBN5YQP5d1k";
var _19 = "wJuLWkP_6R40boXG";
var _1a = "lcX47KTytC4PoU3y";
var _1b = "ghWBHwXXZLE5a0E1";
var _1c = "Zt6zFiai_uU8Lzo0";
var _1d = "JjwX1jmIjQ5Aj8z7";
var _1e = "U8myoL9cSpUgZTJX";
var _1f = "R9a2mcCpdsdq0mYm";
var _20 = "BeA8ZVeuc0Yj00_T";
var _21 = "Ldy5BtenA04wRD7b";
var _22 = "hhdv2VdZH146tQ8o";
var _23 = "xl3nLrTiHwTrWUih";
var _24 = "Tx2cneMtRsQsltP7";
var _25 = "LPdwjk3Fh4O6U_PM";
var _26 = "OW1BaPgxscYBBnny";
export { _1 as "card-divider", _2 as "cardDivider", _3 as "ts-card--medium", _4 as "ts-card--squared", _5 as "ts-player", _6 as "ts-player__country", _7 as "ts-player__img", _8 as "ts-player__img__flag", _9 as "ts-player__img__photo", _a as "ts-player__player", _b as "ts-player__rank", _c as "ts-player__team", _d as "ts-player__team__name", _e as "ts-rank", _f as "ts-rank__label", _10 as "ts-stats", _11 as "ts-stats__assists", _12 as "ts-stats__goals", _13 as "ts-stats__label", _14 as "ts-stats__minutes", _15 as "tsCardMedium", _16 as "tsCardSquared", _17 as "tsPlayer", _18 as "tsPlayerCountry", _19 as "tsPlayerImg", _1a as "tsPlayerImgFlag", _1b as "tsPlayerImgPhoto", _1c as "tsPlayerPlayer", _1d as "tsPlayerRank", _1e as "tsPlayerTeam", _1f as "tsPlayerTeamName", _20 as "tsRank", _21 as "tsRankLabel", _22 as "tsStats", _23 as "tsStatsAssists", _24 as "tsStatsGoals", _25 as "tsStatsLabel", _26 as "tsStatsMinutes" }
